export default "//cloud.imgsmail.ru/cloud.mail.ru/140435/img/build/welcome/attachesWelcomeCover.png";